import {
	ArrowDownwardOutlined,
	ArrowUpwardOutlined,
	DragHandleOutlined,
	EnergySavingsLeafOutlined,
	InfoOutlined,
	LockOutlined,
} from '@mui/icons-material';
import type { ReactNode } from 'react';
import type { FoliarNutrientLevel, MaintenanceFoliarAnalysis } from '../../types';
import styles from './FoliarAnalysisCard.module.css';

interface FoliarAnalysisCardProps {
	analysis: MaintenanceFoliarAnalysis;
}

const LEVELS: Array<{ key: FoliarNutrientLevel; label: string; effect: string; icon: ReactNode }> =
	[
		{
			key: 'below',
			label: 'Abaixo da faixa',
			effect: 'dose aumenta',
			icon: <ArrowUpwardOutlined />,
		},
		{ key: 'adequate', label: 'Adequado', effect: 'dose mantida', icon: <DragHandleOutlined /> },
		{
			key: 'above',
			label: 'Acima da faixa',
			effect: 'dose reduz',
			icon: <ArrowDownwardOutlined />,
		},
	];

const sampledAtFormatter = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' });

export const FoliarAnalysisCard = ({ analysis }: FoliarAnalysisCardProps) => (
	<div className={styles.card}>
		<div className={styles.header}>
			<span className={styles.icon}>
				<EnergySavingsLeafOutlined />
			</span>
			<div className={styles.identity}>
				<div className={styles.titleRow}>
					<span className={styles.title}>{analysis.name}</span>
					{analysis.isLatest && <span className={styles.badge}>Última</span>}
				</div>
				<span className={styles.meta}>
					{[
						analysis.areaName && `Área ${analysis.areaName}`,
						analysis.sectorsLabel && `setores ${analysis.sectorsLabel}`,
						`coletada em ${sampledAtFormatter.format(new Date(analysis.sampledAt))}`,
					]
						.filter(Boolean)
						.join(' · ')}
				</span>
			</div>
			<span className={styles.hint}>
				<LockOutlined />
				Selecionada automaticamente
			</span>
		</div>
		<div className={styles.levels}>
			{LEVELS.map((level) => (
				<div key={level.key} className={styles.level}>
					<span className={styles.levelHeader}>
						<span
							className={`${styles.levelIcon} ${level.key === 'adequate' ? '' : styles.levelIconOut}`}
						>
							{level.icon}
						</span>
						<span className={styles.levelLabel}>{level.label}</span>
						<span className={styles.levelEffect}>· {level.effect}</span>
					</span>
					<div className={styles.chips}>
						{analysis.nutrients[level.key].map((nutrient) => (
							<span
								key={nutrient}
								className={`${styles.chip} ${level.key === 'adequate' ? styles.chipIn : styles.chipOut}`}
							>
								{nutrient}
							</span>
						))}
					</div>
				</div>
			))}
		</div>
		<div className={styles.info}>
			<InfoOutlined className={styles.infoIcon} />
			<span>
				O ajuste usa a análise foliar mais recente da propriedade, área e setores deste
				planejamento. Nutrientes abaixo da faixa adequada aumentam a dose; acima dela, reduzem.
			</span>
		</div>
	</div>
);
